import * as React from "react";
import * as ToggleGroup from "@radix-ui/react-toggle-group";
import { cn } from "@/lib/utils";

/* Selettore a segmenti per viste e periodi, da 2 a 4 voci (pacchetto del 29-10). Tastiera con le frecce
   (ToggleGroup di Radix). Binario angolo 10, voce scelta angolo 7. Sul telefono 44 px. */
export function Segmented({ value, onValueChange, options, size = "md", className, ...aria }) {
  return (
    <ToggleGroup.Root
      type="single"
      value={value}
      // Radix manda "" quando si riclicca la voce scelta: la ignoriamo, una voce resta sempre scelta
      onValueChange={(v) => v && onValueChange(v)}
      aria-label={aria["aria-label"]}
      className={cn("inline-flex gap-0.5 rounded-md bg-track p-[3px]", className)}
    >
      {options.map((o) => (
        <ToggleGroup.Item
          key={o.value}
          value={o.value}
          className={cn(
            "rounded-[7px] px-3.5 font-medium text-ink-2 transition-colors duration-150 ease-enter",
            "data-[state=on]:bg-track-on data-[state=on]:font-bold data-[state=on]:text-ink data-[state=on]:shadow-segment",
            "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand",
            size === "sm" ? "h-8" : "h-9",
            "max-md:h-11",
          )}
        >
          {o.label}
        </ToggleGroup.Item>
      ))}
    </ToggleGroup.Root>
  );
}

/* La stessa forma coi pulsanti veri (aria-pressed e data-testid `<prefisso>-<id>`): la usano Clienti (Kanban /
   Elenco) e Calendario (Giorno / Settimana), dove i giri e i test cercano i pulsanti così. */
export function SegmentedButtons({ voci, valore, onCambia, prefisso, className, ...aria }) {
  return (
    <div
      role="group"
      aria-label={aria["aria-label"]}
      className={cn("inline-flex gap-0.5 rounded-md bg-track p-[3px]", className)}
      data-testid={aria["data-testid"]}
    >
      {voci.map(({ id, label, Icona }) => (
        <button
          key={id}
          type="button"
          aria-pressed={valore === id}
          onClick={() => onCambia(id)}
          data-testid={`${prefisso}-${id}`}
          className={cn(
            "inline-flex h-11 flex-1 items-center justify-center gap-1.5 rounded-[7px] px-3.5 transition-colors duration-150 ease-enter md:h-9",
            "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand",
            valore === id ? "bg-track-on font-bold text-ink shadow-segment" : "font-medium text-ink-2 hover:text-ink",
          )}
        >
          {Icona ? <Icona className="size-4" aria-hidden /> : null}
          {label}
        </button>
      ))}
    </div>
  );
}
